import { sanitizeHtml } from '@/utils/sanitize-html'
import { NotificationItem as NotificationItemType } from '../..'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '@/configs/firebase'
import { useTranslation } from 'react-i18next'
import { Badge, Text } from '@vnetwork/datacentral-ui/primitives'
import { MessageCircle, Clock } from 'lucide-react'

interface NotificationItemProps {
    item: NotificationItemType
}

const NotificationItem: React.FC<NotificationItemProps> = ({ item }) => {
    const navigate = useNavigate()
    const ref = doc(db, `notifications/${item?.id}`)
    const { t } = useTranslation()

    return (
        <div
            onClick={() => {
                navigate(item?.link)

                if (!item?.read)
                    updateDoc(ref, {
                        ...item,
                        read: true,
                    })
            }}
            className={`flex cursor-pointer items-start gap-4 border-b border-border-subtle p-4 transition-colors duration-200 hover:bg-primary-subtle ${!item?.read ? 'border-l-2 border-l-primary-border bg-primary-subtle' : ''}`}
        >
            <div className="shrink-0 pt-1">
                <MessageCircle
                    className={`h-5 w-5 ${!item?.read ? 'text-primary-text' : 'text-muted-foreground'}`}
                />
            </div>

            <div className="flex min-w-0 flex-1 flex-col items-start gap-1">
                <Text as="div" size="sm" weight="medium">
                    {t(item?.title)}
                </Text>

                <Text
                    as="div"
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(t(item?.body)),
                    }}
                    className="line-clamp-2"
                    size="xs"
                    tone="muted"
                />

                <Badge
                    size="sm"
                    tone="primary"
                    startIcon={<Clock className="h-3 w-3" />}
                >
                    {dayjs(item?.created_at?.toDate())?.fromNow()}
                </Badge>
            </div>

            {!item?.read && (
                <div className="mt-2 h-2 w-2 shrink-0 rounded-full bg-primary" />
            )}
        </div>
    )
}

export default NotificationItem
